
import React, { Component } from 'react';
import styled from 'styled-components';

const StyledFormGroup = styled.div`
  margin-bottom: 15px;
  max-width: 490px;
  
  .MuiFormControl-root {
    margin-bottom: 20px;
  }
`;


export default class FormGroup extends Component {
  render() {
    return (
      <StyledFormGroup {...this.props}>
        {this.props.children}
      </StyledFormGroup>
    )
  }
}
